<template>
    <div>
        <client-navigator :current="id" :single-name="$route.meta.singleName"></client-navigator>
        <v-card>
            <v-tabs ref="mastertabs" v-model="activeTab" vertical>
                <v-tab v-for="tab of tabs" :key="tab.id" :to="tab.route" exact>
                    <v-icon left>{{ tab.icon}}</v-icon>
                    {{ tab.name }}
                </v-tab>

                <v-tabs-items v-model="activeTab">
                    <router-view></router-view>
                </v-tabs-items>
            </v-tabs>
        </v-card>
    </div>
</template>

<script>
import ClientNavigator from '@/components/client/ClientNavigator'

export default {
    name: 'detail-client',
    components: {
        ClientNavigator
    },
    props: ['id'],
    data: function () {
        return {
            activeTab: `${this.$route.meta.basePath}/detalhe/${this.id}`,
            tabs: []
        }
    },
    created () {
        this.initializeTabs()
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.activeTab = `${this.$route.meta.basePath}/detalhe/${this.id}`
                    this.$nextTick(() => {
                        this.$refs.mastertabs.callSlider()
                    })
                }
                this.initializeTabs()
            },
            deep: true
        }
    },
    methods: {
        initializeTabs () {
            this.tabs = []
            if (this.$route.meta.tabs.info) {
                this.tabs.push({ id: 1, icon: 'contacts', name: this.$t('labels.info'), route: `${this.$route.meta.basePath}/detalhe/${this.id}` })
            }
            if (this.$route.meta.tabs.demand) {
                this.tabs.push({ id: 2, icon: 'gavel', name: this.$t('labels.demands'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/demandas/ativas` })
            }
            if (this.$route.meta.tabs.timeline) {
                this.tabs.push({ id: 3, icon: 'list', name: this.$t('labels.timeline'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/timeline` })
            }
            if (this.$route.meta.tabs.workedHour) {
                this.tabs.push({ id: 4, icon: 'timer', name: this.$t('labels.workedHours'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/horas_trabalhadas` })
            }
            if (this.$route.meta.tabs.contract) {
                this.tabs.push({ id: 5, icon: 'description', name: this.$t('labels.contracts'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/contratos/ativos` })
            }
            if (this.$route.meta.tabs.corporate) {
                this.tabs.push({ id: 6, icon: 'group_work', name: this.$t('labels.corporate'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/societario/captable` })
            }
            if (this.$route.meta.tabs.brand) {
                this.tabs.push({ id: 7, icon: 'collections', name: this.$t('labels.brands'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/marcas` })
            }
            if (this.$route.meta.tabs.collaborator) {
                this.tabs.push({ id: 8, icon: 'group', name: this.$t('labels.teamMemberPortfolio'), route: `${this.$route.meta.basePath}/detalhe/${this.id}/equipe` })
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
  .v-tab
    justify-content: flex-start
</style>
